var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader1ShapeAWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Asset 4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "M229.15 719q-110.51-.21-220.57-11.45L0 706.7V0h1920v401.73l-14.14-5.05c-114.62-41-229.27-61.78-340.77-61.78-19.07 0-38.32.61-57.21 1.82-85 5.44-161.25 22.33-240 53.14-70.66 27.65-135.05 63.28-203.21 101-102.27 56.58-208 115.1-355.3 160.44a1481 1481 0 01-204.82 47C417.33 712.07 324.66 719 229.18 719z",
    fill: "#e4e8f1"
  }))))));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDEwODAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7b3BhY2l0eTowLjQ7fS5jbHMtMntmaWxsOiNlNGU4ZjE7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJBc3NldF80IiBkYXRhLW5hbWU9IkFzc2V0IDQiIGNsYXNzPSJjbHMtMSI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBpZD0iUGF0aF80NiIgZGF0YS1uYW1lPSJQYXRoIDQ2IiBjbGFzcz0iY2xzLTIiIGQ9Ik0yMjkuMTUsNzE5cS0xMTAuNTEtLjIxLTIyMC41Ny0xMS40NUwwLDcwNi43VjBIMTkyMFY0MDEuNzNsLTE0LjE0LTUuMDVjLTExNC42Mi00MS0yMjkuMjctNjEuNzgtMzQwLjc3LTYxLjc4LTE5LjA3LDAtMzguMzIuNjEtNTcuMjEsMS44Mi04NSw1LjQ0LTE2MS4yNSwyMi4zMy0yNDAsNTMuMTQtNzAuNjYsMjcuNjUtMTM1LjA1LDYzLjI4LTIwMy4yMSwxMDEtMTAyLjI3LDU2LjU4LTIwOCwxMTUuMS0zNTUuMywxNjAuNDRhMTQ4MSwxNDgxLDAsMCwxLTIwNC44Miw0N0M0MTcuMzMsNzEyLjA3LDMyNC42Niw3MTksMjI5LjE4LDcxOVoiLz48L2c+PC9nPjwvZz48L3N2Zz4=";
export { SvgHeader1ShapeAWhite as ReactComponent };